import type { AccountInfo } from '@azure/msal-browser'

export function getDisplayName(account: AccountInfo | null): string {
  return account?.name ?? account?.username ?? 'Gebruiker'
}

export function getFirstName(account: AccountInfo | null): string {
  const full = getDisplayName(account)
  return full.split(' ')[0] ?? full
}

export function getEmployeeEmail(account: AccountInfo | null): string {
  return account?.username ?? ''
}

export function getEmployeeId(account: AccountInfo | null): string | null {
  const claims = account?.idTokenClaims as Record<string, unknown> | undefined
  return (claims?.['oid'] as string) ?? null
}